import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import Tasks from 'APP/Tasks';
import {
  IDeleteCalendarEventParams,
  CalendarModelErrorCode,
} from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';
import Entities from 'STORE';

export const deleteCalendarEvent = async (params: IDeleteCalendarEventParams): Promise<boolean> => {
  if (Entities.App.isOfflineNetworkStatus) {
    popupsTasks.showToast(t('calendar_cannot_delete_event'));
    return false;
  }
  try {
    const response = await calendarModel.deleteCalendarEvent(params);

    popupsTasks.showToast(t('calendar_event_delete_success'));

    if (!response) {
      throw new Error();
    }

    return true;
  } catch (error) {
    if (error.message === CalendarModelErrorCode.Unauthorized) {
      Tasks.calendar.handleCalendarUnauthorized();
    }
    popupsTasks.showToast(t('something_went_wrong'));

    return false;
  }
};
